import { AxiomJSTransport } from "./transports/axiom-js.js";
import { ConsoleTransport } from "./transports/console.js";
import { SimpleFetchTransport } from "./transports/fetch.js";
import { ProxyTransport } from "./transports/proxy-transport.js";
import { EVENT, LogLevel, LogLevelValue, Logger } from "./logger.js";
export {
  AxiomJSTransport,
  ConsoleTransport,
  EVENT,
  LogLevel,
  LogLevelValue,
  Logger,
  ProxyTransport,
  SimpleFetchTransport
};
//# sourceMappingURL=index.js.map
